export const PDBLink = (pdb) => <a href={"https://www.rcsb.org/structure/" + pdb.value} target="_blank" rel="noopener noreferrer"> {pdb.value} </a>
